import type {QueryClient} from "@tanstack/react-query";
import {GET_STORE_SUBSCRIPTION_RQ_KEY} from "../constants";
import {invalidateSubscriptionListQueries} from "../invalidate-subscription-lists";

export function invalidateSubscriptionAfterTierChange(
  queryClient: QueryClient,
  subscriptionId: number
) {
  queryClient.invalidateQueries({
    queryKey: [GET_STORE_SUBSCRIPTION_RQ_KEY, String(subscriptionId)],
  });
  invalidateSubscriptionListQueries(queryClient);
}
